import React, { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalBody,
  IconButton,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { POSITION_CLASSES } from '../../utils';
import { FullscreenImage } from '../../components';
import { SingleHoop, HoopsClusterGrid } from './components';

const HoopsModal = ({ hoops, onAfterClose, onAddToExistingHoop, position = 'top' }) => {
  const [ page, setPage ] = useState(0);
  const [ viewMode, setViewMode ] = useState('single'); // 'single' or 'cluster'
  const [ imgFullOpen, setImgFullOpen ] = useState(false);
  const [ activeImageUrl, setActiveImageUrl ] = useState(null);

  const { cluster, clusterMeta, modalOpen } = hoops;

  const handleClose = () => {
    setPage(0);
    setViewMode('single');
    onAfterClose();
  };

  // imageUrl added for reebok which has carousel of images
  // and therefore the current hoop image is not correct
  const toggleImgFullscreen = ({ imageUrl }) => {
    if (imageUrl) {
      setActiveImageUrl(imageUrl);
    } else {
      setActiveImageUrl(null);
    }
    setImgFullOpen(!imgFullOpen);
  };

  const paginateTo = (pageIndex) => {
    setPage(pageIndex);
  };

  const paginateNext = () => {
    const nextPageIndex = page + 1;
    if (nextPageIndex !== cluster.length) {
      setPage(nextPageIndex);
    }
  };
  const paginatePrev = () => {
    const nextPageIndex = page - 1;
    if (nextPageIndex >= 0) {
      setPage(nextPageIndex);
    }
  };

  const showClusterGrid = () => {
    setViewMode('cluster');
  };

  const showSingleHoop = (hoop) => {
    const pageIndex = cluster.indexOf(hoop);
    paginateTo(pageIndex);
    setViewMode('single');
  };

  const singleHoopView = (hoop) => {
    const sharedProps = {
      page,
      numOfClusterHoops: cluster.length,
      showClusterGrid,
      onAddToExistingHoop,
      paginatePrev,
      paginateNext,
      toggleImgFullscreen,
    };

    return <SingleHoop {...{ hoop, ...sharedProps }} />;

    // switch (hoop?.brand) {
    // case 'reebok':
    //   return <Reebok {...{ hoop, ...sharedProps }} />;

    // default:
    //   return <SingleHoop {...{ hoop, ...sharedProps }} />;
    // }
  };

  const currentHoop = cluster[page];

  return (
    <div className={POSITION_CLASSES[position]}>
      <div className="leaflet-control">
        <Modal
          isOpen={modalOpen}
          onClose={handleClose}
          size="6xl"
          isCentered
          motionPreset="none"
          scrollBehavior="inside"
          autoFocus={false}
          closeOnOverlayClick={false}
          blockScrollOnMount={false}
          id="hoops-modal"
        >
          <ModalOverlay bg="blackAlpha.600" />
          <ModalContent
            mx={[ '0', '8' ]}
            my={[ '0', '8' ]}
            h={[ 'full', 'auto' ]}
            maxH={[ 'unset', '90vh' ]}
            borderRadius="0"
            boxShadow="none"
          >
            <IconButton
              onClick={handleClose}
              aria-label="Close"
              icon={<FontAwesomeIcon icon={[ 'fas', 'times' ]} size="lg" />}
              size="sm"
              colorScheme="blackAlpha"
              pos="absolute"
              right={[ '2', '2', '-4' ]}
              top={[ '2', '2', '-4' ]}
              rounded="full"
              zIndex="overlay"
            />

            <ModalBody p="0" h="full">
              {viewMode === 'cluster'
                ? (
                  <HoopsClusterGrid
                    cluster={cluster}
                    clusterInfo={clusterMeta}
                    showSingleHoop={showSingleHoop}
                  />
                )
                : singleHoopView(currentHoop)}
            </ModalBody>
          </ModalContent>
        </Modal>
        <FullscreenImage
          isOpen={imgFullOpen}
          onClose={() => setImgFullOpen(false)}
          imgUrl={activeImageUrl || currentHoop?.image?.url}
        />
      </div>
    </div>
  );
};

export default HoopsModal;
